import { httpV2 } from "@/api/index";

/**
 * Solicita o resultado do modo de falha de desalinhamento angular.
 * @param {Number} resultId Id do resultado geral do modo de falha.
 * @returns {promise} Retorna status do diagnóstico.
 */
const GetAngularDiagnostics = function(resultId)
{
	return httpV2.get(`/HydroGeneratingUnitDiagnostic/${resultId}/AngularMisalignment`);
};

/**
 * Solicita o resultado do modo de falha de desalinhamento paralelo.
 * @param {Number} resultId Id do resultado geral do modo de falha.
 * @returns {promise} Retorna status do diagnóstico.
 */
const GetParallelDiagnostics = function(resultId)
{
	return httpV2.get(`/HydroGeneratingUnitDiagnostic/${resultId}/ParallelMisalignment`);
};

export default { GetAngularDiagnostics, GetParallelDiagnostics };